import axios from 'axios'

export default {
	login({ commit }, payload) {
		// console.log(payload)
		commit('UPDATE_USER', payload)
	},
	tryAutoLogin({ commit }) {
		axios.interceptors.response.use(null, (error) => {
			if(error.response && error.response.status == 401) {				
				window.location.href = '/';
				commit('LOGOUT_USER')
			}
			return Promise.reject(error);
		});

		axios.interceptors.request.use(
		  (config) => {
		    let token = localStorage.getItem('token');

		    if (token) {
		    	if ( token != 'null' ) {
		    		config.headers.common['Authorization'] = `Bearer ${ token }`;
		    	}
		    }

		    return config;
		  }, 

		  (error) => {
		    return Promise.reject(error);
		  }
		);

		let updateUser = {
			detail: {
				id: localStorage.getItem('userid'),
				name: localStorage.getItem('name'),
				email: localStorage.getItem('email'),
				merchant_aliases: localStorage.getItem('alias')
			},
			access_token: localStorage.getItem('token')
		}

		commit('UPDATE_USER', updateUser)		
	},
	logout({ commit }) {
		commit('LOGOUT_USER')
	}
}